module.exports = __webpack_public_path__ + "img/kejizhuanlan.8395e409.jpg";